import { Group } from '@/components/_common';
import {
  useFavoriteHelpItem,
  useUnfavoriteHelpItem,
} from '@/core/domain/helpcenter/HelpItems/HelpItems.hooks';
import { HelpItem } from '@/core/domain/helpcenter/HelpItems/HelpItems.types';
import { Button } from 'antd';
import { useState } from 'react';
import { Bookmark } from 'react-feather';

interface Props {
  helpItem?: HelpItem;
}

export default function HelpCenterFavoriteToggle(props: Props) {
  const [isFavorite, setIsFavorite] = useState(
    props.helpItem?.favorite ?? false,
  );

  const favorite = useFavoriteHelpItem();
  const unfavorite = useUnfavoriteHelpItem();

  const toggleFavorite = async () => {
    if (!props.helpItem?.id) return;

    setIsFavorite((prev) => !prev);

    try {
      if (isFavorite) {
        await unfavorite.mutateAsync(props.helpItem.id);
      } else {
        await favorite.mutateAsync(props.helpItem.id);
      }
    } catch {
      setIsFavorite((prev) => !prev);
    }
  };

  return (
    <Button
      block
      onClick={toggleFavorite}
      type={isFavorite ? 'primary' : 'default'}
    >
      <Group position="center">
        <Bookmark size={16} />

        {isFavorite ? 'Desfavoritar' : 'Favoritar'}
      </Group>
    </Button>
  );
}
